export default __webpack_public_path__ + "static/media/1712.35e9cd06.png";